var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRomanticDinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53482_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.449 13.475C16.449 15.318 14.135 17.588 12.82 18.672C12.289 19.11 11.531 19.11 11 18.672C9.685 17.588 7.449 15.318 7.449 13.475C7.449 12.108 8.456 11 9.699 11C10.942 11 11.949 12.108 11.949 13.475C11.949 12.108 12.956 11 14.199 11C15.442 11 16.449 12.108 16.449 13.475ZM24 7.5V18.5C24 21.533 21.533 24 18.5 24H5.5C2.467 24 0 21.533 0 18.5V7.5C0 4.467 2.467 2 5.5 2H6V1.5C6 0.671 6.671 0 7.5 0C8.329 0 9 0.671 9 1.5V2H15V1.5C15 0.671 15.671 0 16.5 0C17.329 0 18 0.671 18 1.5V2H18.5C21.533 2 24 4.467 24 7.5ZM21 18.5V9H3V18.5C3 19.878 4.122 21 5.5 21H18.5C19.878 21 21 19.878 21 18.5Z",
    fill: "#1D1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53482_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomanticDinner);
export default __webpack_public_path__ + "static/media/romantic-dinner.3f470dbea190e9350380a57267906900.svg";
export { ForwardRef as ReactComponent };